// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1554":"css/app.6774","9259":"css/admin-app.6774"}[chunkId] + ".css";
};